export default "__VITE_ASSET__92572230__"